'use client';

import { ARCHITECTURE_VERSION, type ArchitectureVersion } from '@/utils/constants';

interface Segment {
  value: ArchitectureVersion;
  label: string;
  descriptor?: string;
}

const SEGMENTS: Segment[] = [
  { value: ARCHITECTURE_VERSION.A2, label: 'A2', descriptor: 'Default' },
  { value: ARCHITECTURE_VERSION.A1, label: 'A1', descriptor: 'Legacy' },
  { value: ARCHITECTURE_VERSION.CUSTOM, label: 'Custom' },
];

interface Props {
  value: ArchitectureVersion;
  onChange: (value: ArchitectureVersion) => void;
}

const ArchitectureSegmentedControl = ({ value, onChange }: Props) => {
  return (
    <div
      role="tablist"
      aria-label="Model architecture"
      className="inline-flex items-center w-[352px] h-[54px] p-2 rounded-[100px] bg-zinc-900"
    >
      {SEGMENTS.map((segment) => {
        const isSelected = value === segment.value;
        const isCustom = segment.value === ARCHITECTURE_VERSION.CUSTOM;
        return (
          <button
            key={segment.value}
            type="button"
            role="tab"
            aria-selected={isSelected}
            onClick={() => onChange(segment.value)}
            className={`flex-1 h-full flex items-center justify-center gap-2 rounded-full transition-colors duration-150 ${
              isCustom ? 'font-mono text-sm font-normal' : 'text-base font-bold'
            } ${isSelected ? 'bg-white text-black' : 'text-zinc-400'}`}
          >
            <span>{segment.label}</span>
            {segment.descriptor && (
              <span
                className={`text-xs font-normal ${isSelected ? 'text-black' : 'text-zinc-400'}`}
              >
                {segment.descriptor}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ArchitectureSegmentedControl;
